module.exports = __webpack_public_path__ + "media/images/gallery/constellations/figure_layer_off-31fd08ccfcdce3a72204cde20608563d.png";